import { Route, lazyRouteComponent } from "@tanstack/react-router";
import { rootRoute } from "./root";

export const termsAndConditionsRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/terms-and-conditions",
  component: lazyRouteComponent(() => import("../pages/terms-and-conditions")),
});
